import React, {useState, useEffect} from 'react';
import { useSelector } from "react-redux";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { TextField } from "@mui/material";
import { Switch } from "@mui/material";
import { FaRegClock } from "react-icons/fa6";
import { CircularProgress } from "@mui/material";
import Button from '@mui/material/Button';
import { IoRefresh } from "react-icons/io5";
import axios from "axios";
import TriggerModal from './TriggerModal';
import ColorPickerModal from '../../component/ColorPickerModal';
const MINIMUM_RGBMODULE_VERSION = process.env.REACT_APP_MINIMUM_RGBMODULE_VERSION;
const MINIMUM_MONORELAISMODULE_VERSION = process.env.REACT_APP_MINIMUM_MONORELAISMODULE_VERSION;
const BE_URI = process.env.REACT_APP_BE_URI;

const WifiModuleControls = ({wifiModule, t, i18n}) => {

  const wifiModuleData = [];
  const setWifiModuleData = () => {};

  const currentMainThemeColor = localStorage.getItem("currentMainThemeColor") ?? "#135c13";
  const currentSecondaryThemeColor = localStorage.getItem("currentSecondaryThemeColor") ?? "#cfcfcf";
  const { user: currentUser } = useSelector((state) => state.auth);
    
  const relay1Function =
    wifiModule.functions?.includes('relais') ||
    wifiModule.functions?.includes('rgb');
  const rgbFunction = wifiModule.functions?.includes('rgb');
  const [selectedLightMode, setSelectedLightMode] = useState('m');
  const [relay1, setRelay1] = React.useState(false);
  const [triggers, setTriggers] = React.useState([]);
  const [numLEDs, setNumLEDs] = React.useState('0');
  const [timeZone, setTimeZone] = React.useState(-5);
  const [firmwareVersion, setFirmwareVersion] = React.useState("0.0.0");
  const [isFirmwareVersionOutdated, setIsFirmwareVersionOutdated] = React.useState(false);
  const [isFirmwareUpdating, setIsFirmwareUpdating] = React.useState(false);
  const [triggerModalVisible, setTriggerModalVisible] = React.useState(false);
  const [loadingReadData, setLoadingReadData] = React.useState(false);
  const [loadingReadDataError, setLoadingReadDataError] = React.useState(false);
  const [isMainThemeModalVisible, setIsMainThemeModalVisible] = React.useState(false);

  const handleDownloadUpdate = async (urlToSend) => {
    try {
      const formData = {
        url: '' + urlToSend,
        data: 'update',
      };
      const res = await axios.post(BE_URI + '/send-data', formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          authorization: `Bearer ${currentUser.token}`,
        },
      });

      if (res.data.success) {
        console.log(t('SuccesfullySendData'));
        setIsFirmwareUpdating(true);
      } else {
        console.log('Error: ' + res.data.message);
        setLoadingReadDataError(true);
      }
    } catch (error) {
      console.log('Error : ' + error);
    }
  };

  const handleMainThemeModal = () => {
    setIsMainThemeModalVisible(!isMainThemeModalVisible);
  };

  const [currentMainThemeColorArduino, setCurrentMainThemeColorArduino] =
    useState('#0000FF');

  const [
    currentSecondaryThemeColorArduino,
    setCurrentSecondaryThemeColorArduino,
  ] = useState('#0000FF');

  const setMainThemeColor = async color => {
    setCurrentMainThemeColorArduino(color);
    try {
      const formData = {
        url: '' + wifiModule.writeUrl,
        data: 'mainTheme:'+color,
      };
      const res = await axios.post(BE_URI + '/send-data', formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          authorization: `Bearer ${currentUser.token}`,
        },
      });

      if (res.data.success) {
        console.log(t('SuccesfullySendData'));
      } else {
        console.log('Error: ' + res.data.message);
      }
    } catch (error) {
      console.log('Error : ' + error);
    }
  };

  const [isSecondaryThemeModalVisible, setIsSecondaryThemeModalVisible] =
    React.useState(false);
  const handleSecondaryThemeModal = () =>
    setIsSecondaryThemeModalVisible(!isSecondaryThemeModalVisible);

  const setSecondaryThemeColor = async color => {
    setCurrentSecondaryThemeColorArduino(color);
    try {
      const formData = {
        url: '' + wifiModule.writeUrl,
        data: 'secondaryTheme:'+color,
      };
      const res = await axios.post(BE_URI + '/send-data', formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          authorization: `Bearer ${currentUser.token}`,
        },
      });

      if (res.data.success) {
        console.log(t('SuccesfullySendData'));
      } else {
        console.log('Error: ' + res.data.message);
      }
    } catch (error) {
      console.log('Error : ' + error);
    }
  };

  function isVersionGreaterThan(version1, version2) {

    const v1Components = version1.split('.').map(Number);
    const v2Components = version2.split('.').map(Number);

    for (let i = 0; i < Math.max(v1Components.length, v2Components.length); i++) {
        const v1Value = v1Components[i] || 0;
        const v2Value = v2Components[i] || 0;

        if (v1Value > v2Value) {
            return true;
        } else if (v1Value < v2Value) {
            return false;
        }
    }

    return false;
}

  const handleLightModeChangeSendData = async (urlToSend, mode) => {
    try {
      const formData = {
        url: '' + urlToSend,
        data: 'mode:'+mode,
      };
      const res = await axios.post(BE_URI + '/send-data', formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          authorization: `Bearer ${currentUser.token}`,
        },
      });

      if (res.data.success) {
        console.log(t('SuccesfullySendData'));
      } else {
        console.log('Error: ' + res.data.message);
      }
    } catch (error) {
      console.log('Error : ' + error);
    }
  };

  const handleRelaisSendData = async urlToSend => {
    try {
      const formData = {
        url: '' + urlToSend,
        data: relay1 ? 'relaisoff' : 'relaison',
      };
      const res = await axios.post(BE_URI + '/send-data', formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          authorization: `Bearer ${currentUser.token}`,
        },
      });

      if (res.data.success) {
        console.log(t('SuccesfullySendData'));
      } else {
        console.log('Error: ' + res.data.message);
      }
    } catch (error) {
      console.log('Error : ' + error);
    }
  };

    const handleNumLEDChange = async (text) => {
      // Convert text to a number
      const num = parseInt(text, 10);
      // Check if the number is within the range
      if (num >= 1 && num <= 300) {
        try {
          const formData = {
            url: '' + wifiModule.writeUrl,
            data: 'rgbAmount:'+num,
          };
          const res = await axios.post(BE_URI + '/send-data', formData, {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              authorization: `Bearer ${currentUser.token}`,
            },
          });
    
          if (res.data.success) {
            console.log(t('SuccesfullySendData'));
            setNumLEDs(text);
          } else {
            console.log('Error: ' + res.data.message);
          }
        } catch (error) {
          console.log('Error : ' + error);
        }
      } 
    };

  const handleReadData = async () => {
    //Request Read state-data
    try {
      setLoadingReadData(true);
      const formData = {
        readUrl: '' + wifiModule.readUrl,
        writeUrl: '' + wifiModule.writeUrl,
      };
      const res = await axios.post(BE_URI + '/read-data', formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          authorization: `Bearer ${currentUser.token}`,
        },
      });

      if (res.data.success) {
        
        const jsonObject = JSON.parse(res.data.data);
        const oldDataExcludingCurrentModule = wifiModuleData.filter(moduleData => moduleData.extraInfo != jsonObject.extraInfo);
        setWifiModuleData([...oldDataExcludingCurrentModule, jsonObject]);

        if (jsonObject.relais1) {
          setRelay1(true);
        } else {
          setRelay1(false);
        }

        if (jsonObject.triggersRelais1) {
          setTriggers(jsonObject.triggersRelais1);
        }

        if (jsonObject.timeZone) {
          setTimeZone(jsonObject.timeZone);
        }

        if(jsonObject.version){
          setFirmwareVersion(jsonObject.version);
          if(wifiModule.functions?.includes('rgb') && isVersionGreaterThan(MINIMUM_RGBMODULE_VERSION, jsonObject.version)){
            setIsFirmwareVersionOutdated(true);
            console.log("RGB VERSION TOO LOW, MUST UPDATE");
          } 
          if(wifiModule.functions?.includes('relais') && isVersionGreaterThan(MINIMUM_MONORELAISMODULE_VERSION, jsonObject.version)){
            setIsFirmwareVersionOutdated(true);
            console.log("RELAIS VERSION TOO LOW, MUST UPDATE");
          }
        }


        if (jsonObject.mode) {
          setSelectedLightMode(jsonObject.mode);
        }
        
        if(jsonObject.numLEDS){
          setNumLEDs(jsonObject.numLEDS);
        }

        if (jsonObject.mainTheme) {
          setCurrentMainThemeColorArduino(jsonObject.mainTheme);
        }

        if (jsonObject.secondaryTheme) {
          setCurrentSecondaryThemeColorArduino(jsonObject.secondaryTheme);
        }

        setLoadingReadData(false);
      } else {
        console.log('Error: ' + res.data.message);
        setLoadingReadData(false);
        setLoadingReadDataError(true);
      }
    } catch (error) {
      console.log('Error : ' + error);
      setLoadingReadData(false);
    }
  };

  const handleReadStoredData = () => {
    const currentModule = wifiModuleData.find(item => item.extraInfo.includes(wifiModule.writeUrl));
    if (currentModule.relais1) {
      setRelay1(true);
    } else {
      setRelay1(false);
    }

    if (currentModule.triggersRelais1) {
      setTriggers(currentModule.triggersRelais1);
    }

    if (currentModule.timeZone) {
      setTimeZone(currentModule.timeZone);
    }
    if(currentModule.version){
      setFirmwareVersion(currentModule.version);
      if(wifiModule.functions?.includes('rgb') && isVersionGreaterThan(MINIMUM_RGBMODULE_VERSION, currentModule.version)){
        setIsFirmwareVersionOutdated(true);
        console.log("RGB VERSION TOO LOW, MUST UPDATE");
      } 
      if(wifiModule.functions?.includes('relais') && isVersionGreaterThan(MINIMUM_MONORELAISMODULE_VERSION, currentModule.version)){
        setIsFirmwareVersionOutdated(true);
        console.log("RELAIS VERSION TOO LOW, MUST UPDATE");
      }
        
    }

    if (currentModule.mode) {
      setSelectedLightMode(currentModule.mode);
    }

    if(currentModule.numLEDS){
      
      setNumLEDs(currentModule.numLEDS);
    }

    if (currentModule.mainTheme) {
      setCurrentMainThemeColorArduino(currentModule.mainTheme);
    }

    if (currentModule.secondaryTheme) {
      setCurrentSecondaryThemeColorArduino(currentModule.secondaryTheme);
    }
  };

  useEffect(() => {
    const noNeedToReFetch = wifiModuleData.some(item => item.extraInfo.includes(wifiModule.writeUrl));
    if(noNeedToReFetch){
      handleReadStoredData();
    } else {
      handleReadData();
    }
  }, []);


  if (loadingReadData) {
    return (
    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 15}}>
      <CircularProgress style={{ marginBottom: 1, color: currentMainThemeColor, alignSelf: 'center'}} size={60} />
    </div>
    )
  }

  return (
    <div style={styles.sectionContainer}>
      {loadingReadDataError && (
        <div style={{marginTop: 10, marginBottom: 10, justifyContent: 'center', alignItems: 'center'}}>
          <p style={{color: 'red', textAlign: 'center', whiteSpace: 'pre-wrap'}}>
            {t('ErrorLoadingWifiModuleData')}
          </p>
        </div>
      )}
      {!loadingReadDataError && (
        <div style={{display: 'flex', flexDirection: 'column', marginTop: 10, marginBottom: 10, justifyContent: 'center', alignItems: 'center'}}>
          <IoRefresh
            color={currentMainThemeColor}
            size={40}
            style={styles.clickable}
            onClick={() => {
              handleReadData();
            }}
          />
          <p style={{color: 'gray', textAlign: 'center'}}>
            {t('Firmware')+" V"+firmwareVersion}
          </p>
        </div>
      )}
      {!loadingReadDataError && isFirmwareVersionOutdated && !isFirmwareUpdating && (
        <div style={{marginBottom: 10}}>
          <p style={{color: 'gray', textAlign: 'center', width: 200, marginBottom: 8}}>
            {t('FirmwareOutDatedPleaseUpdate')}
          </p>
          <Button
            title={t('Download')}
            color={currentMainThemeColor}
            onClick={() => handleDownloadUpdate(wifiModule.writeUrl)}
          />
        </div>
      )}
      {!loadingReadDataError && isFirmwareUpdating && (
        <div style={{display: 'flex', marginBottom: 10, justifyContent: 'center'}}>
          <p style={{color: 'gray', textAlign: 'center', width: 200, marginBottom: 8}}>
            {t('FirmwareUpdating')}
          </p>
        </div>
      )}
      <div style={{display: 'flex', flexDirection: 'row', marginTop: 10, justifyContent: 'center'}}>
        {!isFirmwareVersionOutdated && relay1Function && (
          <div style={{display: 'flex', flexDirection: 'row'}}>
            <Switch
              trackColor={{
                false: currentSecondaryThemeColor,
                true: currentSecondaryThemeColor,
              }}
              thumbColor={currentMainThemeColor}
              ios_backgroundColor="#3e3e3e"
              
              onChange={() => {
                handleRelaisSendData(wifiModule.writeUrl).then(() => {
                  setRelay1(!relay1);
                });
              }}
              checked={relay1}
            />
            <div style={{marginStart: 16}}>
              {!loadingReadDataError && (
                <FaRegClock
                  color={currentMainThemeColor}
                  style={styles.clickable}
                  size={25}
                  onClick={() => {
                    setTriggerModalVisible(true);
                  }}
                />
              )}
            </div>
          </div>
        )}
      </div>
      {!isFirmwareVersionOutdated && !loadingReadDataError && rgbFunction && (
        <>
          <div style={{ alignSelf: 'center', marginTop: 10, borderWidth: 1, borderColor: currentMainThemeColor, width: 110, display: 'flex', flexDirection: 'row' }}>
            <TextField
              style={{ textAlign: 'center', alignSelf: 'center', width: 150 }}
              type="number"
              value={numLEDs.toString()}
              onChange={(e) => handleNumLEDChange(e.target.value)}
              maxLength={3} 
            />
            <p style={{ textAlign: 'center', alignSelf: 'center' }}>{'LEDs'}</p>
          </div>
          <p style={{textAlign: 'center', marginTop: 12}}>{t('LightMode') + ':'}</p>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginStart: 22,
            }}>
            <FormControl style={{ height: 90, width: 250, marginTop: -12 }}>
              <InputLabel id="light-mode-select-label">Light Mode</InputLabel>
              <Select
                labelId="light-mode-select-label"
                value={selectedLightMode}
                onChange={(event) => {
                  const itemValue = event.target.value;
                  setSelectedLightMode(itemValue);
                  handleLightModeChangeSendData(wifiModule.writeUrl, itemValue);
                }}
              >
                <MenuItem value="m">Multi Color Line</MenuItem>
                <MenuItem value="n">Multi Color Switching</MenuItem>
                <MenuItem value="u">Multi Color Alternate Switching</MenuItem>
                <MenuItem value="v">Multi Color Wave</MenuItem>
                <MenuItem value="r">Multi Color Rainbow</MenuItem>
                <MenuItem value="d">Double Color</MenuItem>
                <MenuItem value="t">Double Color Smooth</MenuItem>
                <MenuItem value="h">Double Color Half Smooth</MenuItem>
                <MenuItem value="a">Double Color Alternate</MenuItem>
                <MenuItem value="w">Double Color Alternate Switching</MenuItem>
                <MenuItem value="s">Single Color</MenuItem>
              </Select>
            </FormControl>
          </div>
        </>
      )}
      <div style={{ display: 'flex', flexDirection: 'column'}}>
        {!isFirmwareVersionOutdated && !loadingReadDataError && rgbFunction && selectedLightMode != 'm' && selectedLightMode != 'n' && selectedLightMode != 'u' && selectedLightMode != 'v' && selectedLightMode != 'r' && (
          <Button>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                marginTop: 12,
                justifyContent: 'space-between',
              }}>
              <p style={{fontSize: 20}}>{t('LightsColor')}:</p>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  marginStart: 4,
                }}>
                <Button
                  title="     "
                  style={{ background: currentMainThemeColorArduino }}
                  color={currentMainThemeColorArduino}
                  onClick={handleMainThemeModal}
                />
              </div>
            </div>
          </Button>
        )}
        {!isFirmwareVersionOutdated && !loadingReadDataError && rgbFunction && selectedLightMode != 's' && selectedLightMode != 'm' && selectedLightMode != 'n' && selectedLightMode != 'u' && selectedLightMode != 'v' && selectedLightMode != 'r' && (
          <Button style={{
            marginTop: 6,
          }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                
                justifyContent: 'space-between',
              }}>
              <p style={{fontSize: 16}}>{t('secondaryLightsColor')}:</p>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  marginStart: 4,
                }}>
                <Button
                  title="     "
                  style={{ margin: '5px', background: currentSecondaryThemeColorArduino }}
                  color={currentSecondaryThemeColorArduino}
                  onClick={handleSecondaryThemeModal}
                />
              </div>
            </div>
          </Button>
        )}
      </div>
      {!loadingReadDataError && (
        <TriggerModal
          token={currentUser.token}
          triggers={triggers}
          timeZone={timeZone}
          handleReadData={handleReadData}
          urlToSend={wifiModule.writeUrl}
          buttonColor={currentMainThemeColor}
          modalVisible={triggerModalVisible}
          currentSecondaryThemeColor={currentSecondaryThemeColor}
          setModalVisible={setTriggerModalVisible}
          t={t}
          i18n={i18n}
        />
      )}
      <ColorPickerModal
        currentColor={currentMainThemeColorArduino}
        buttonColor={currentMainThemeColor}
        modalVisible={isMainThemeModalVisible}
        setModalVisible={setIsMainThemeModalVisible}
        setColor={setMainThemeColor}
      />
      <ColorPickerModal
        currentColor={currentSecondaryThemeColorArduino}
        buttonColor={currentMainThemeColor}
        modalVisible={isSecondaryThemeModalVisible}
        setModalVisible={setIsSecondaryThemeModalVisible}
        setColor={setSecondaryThemeColor}
      />
    </div>
  );
};

const styles = {
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  clickable: {
    cursor: 'pointer'
  }
};

export default WifiModuleControls;
